import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchUsersByQuery } from '../../api/users';
import { enqueueSnackbarAction } from '../notifications/actions';
import { FETCH_USERS, requestUsers, requestUsersFailure, requestUsersSuccess } from './actions';

function* fetchUsersSaga(action: AnyAction): SagaIterator {
    yield put(requestUsers());

    const { error, response } = yield call(fetchUsersByQuery, action.query);

    if (error) {
        yield put(
            enqueueSnackbarAction({
                message: 'Fehler: Kunden konnten nicht geladen werden!' + error.message,
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'error',
                },
            })
        );
        yield put(requestUsersFailure(error));
    } else {
        yield put(
            enqueueSnackbarAction({
                message: response.statusText || 'Kunden erfolgreich geladen',
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'success',
                },
            })
        );
        yield put(requestUsersSuccess(response));
    }
}

export function* generateFetchUsers() {
    yield takeLatest(FETCH_USERS, fetchUsersSaga);
}
